import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"aditools-precision-studio-dropdown\" {{this.renderer this.insertedMenu this.destroyingMenu}} />\n")